import Vue from 'vue';
import App from './App.vue';
import '@/styles/global.scss';
import router from './router';
import store from './store';
import globalPlugins from '@/plugins/global';
import { initHttpService } from '@/services/http-service';
import Vuelidate from 'vuelidate';

Vue.config.productionTip = false;
//подключаем глобальные плагины
Vue.use(globalPlugins);
// подключаем библиотеку для валидации форм
Vue.use(Vuelidate);
// инициализация сервиса доступа к api
initHttpService(store, router);

// создание корневого комопнента Vue
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
